import React, { useEffect, useRef, useState } from 'react';
import { normalizeAdCreative } from '../utils/adMarketplace';
export default function AdCreativeRenderer({ campaign, compact = false, onReady, onAssetError, onInteraction, onQualifiedView, isVisible = () => false }) {
    const creative = normalizeAdCreative(campaign);
    const destinationUrl = creative.destinationUrl || creative.url;
    const title = creative.title || 'Sponsored';
    const assetUrl = creative.assetUrl || creative.imageUrl;
    const [failed, setFailed] = useState(false);
    const playback = useRef({ last: null, elapsed: 0, reported: false });
    useEffect(() => {
        setFailed(false);
        playback.current = { last: null, elapsed: 0, reported: false };
        if (!assetUrl) onReady?.();
    }, [assetUrl, onReady]);
    const mediaError = () => { setFailed(true); onAssetError?.(); };
    const start = () => { playback.current.last = performance.now(); };
    const stop = () => { playback.current.last = null; };
    const progress = event => {
        const media = event.currentTarget;
        const current = playback.current;
        const now = performance.now();
        if (current.last !== null && !media.paused && !media.seeking && !document.hidden && isVisible()) {
            const delta = now - current.last;
            if (delta > 0 && delta <= 2000) current.elapsed += delta;
        }
        current.last = media.paused || media.seeking ? null : now;
        if (!current.reported && current.elapsed >= 10000) {
            current.reported = true;
            Promise.resolve(onQualifiedView?.()).then(recorded => { if (recorded === false) current.reported = false; });
        }
    };
    const openProps = destinationUrl ? { href: destinationUrl, target: '_blank', rel: 'noopener noreferrer', onClick: onInteraction } : {};
    const Container = destinationUrl ? 'a' : 'div';
    const heading = <h3 style={{ marginTop: 0 }}>{title}</h3>;
    const copy = creative.body ? <p style={{ whiteSpace: 'pre-wrap' }}>{creative.body}</p> : null;
    const image = assetUrl && !failed ? <img src={assetUrl} alt={title} loading="lazy" decoding="async" onLoad={onReady} onError={mediaError} style={{ width: '100%', borderRadius: 8, display: 'block', marginBottom: 8 }} /> : null;
    const error = failed ? <p role="alert">This ad creative is currently unavailable.</p> : null;
    if (['video', 'audio'].includes(creative.medium)) {
        const Media = creative.medium;
        return <div>
            {heading}{copy}
            {assetUrl && !failed ? <Media src={assetUrl} controls preload="metadata" onLoadedData={onReady} onError={mediaError} onPlay={start} onPause={stop} onSeeking={stop} onSeeked={start} onEnded={stop} onTimeUpdate={progress} style={{ width: '100%', borderRadius: 8 }} /> : null}
            {error}
            {destinationUrl ? <a {...openProps}>Open advertiser link</a> : null}
        </div>;
    }
    return <Container {...openProps} style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>
        {['image', 'link'].includes(creative.medium) ? image : null}
        {heading}{copy}{error}
        {destinationUrl && creative.medium !== 'image' && !compact ? <span style={{ textDecoration: 'underline' }}>{destinationUrl}</span> : null}
    </Container>;
}
